import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/lebenslauf/components/frame/src/assets/lebenslauf-logo-dark.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')